/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : CPS
 * @lastTime     : 2024-11-05 16:01:12
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/radioGroup.js
 */
export default {
    // radio-group组件
    radioGroup: {
        value: '',
        disabled: false,
        shape: 'circle',
        activeColor: '#2979ff',
        inactiveColor: '#c8c9cc',
        name: '',
        size: 18,
        placement: 'row',
        label: '',
        labelColor: '#303133',
        labelSize: 14,
        labelDisabled: false,
        iconColor: '#ffffff',
        iconSize: 12,
        borderBottom: false,
        iconPlacement: 'left',
        gap: "10px"
    }
}
